<template>
  <div>
    <SweetModal ref="modalRef" :hide-close-button="true" class="vld-parent">
      <div class="modal-content-wrapper">
        <div class="modal-main-content">
          <TagsInput
            v-model="tag"
            :tags="tags"
            :max-tags="50"
            :add-on-key="[32, 13]"
            :validate="validateTag"
            :placeholder="$t('tags.placeholder_add_tag')"
            @on-tags-changed="onTagsChanged"
          />

          <h5 class="text-muted">{{ $t('tags.tags_limitation_msg') }}</h5>

          <p v-if="invalidTag" style="color: red">
            {{ $t('tags.invalid_tag') }}: <span>{{ invalidTag }}</span>
          </p>
        </div>
      </div>

      <template #button>
        <button class="btn btn-default right-margin" @click="close">
          {{ $t('modals.close_button') }}
        </button>
        <button class="btn btn-primary" @click="save">
          {{ $t('modals.save_button') }}
        </button>
      </template>
    </SweetModal>
  </div>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue-3';
import TagsInput from 'vue3-tags-input';
import {mapState, mapMutations, mapActions} from 'vuex';

export default {
  name: 'TagsModal',
  components: {
    SweetModal,
    TagsInput
  },
  data() {
    return {
      tag: '',
      tags: [],
      invalidTag: ''
    };
  },
  computed: {
    ...mapState({
      success: state => state.success,
      conflict: state => state.conflict,
      customerTags: state => state.customerTags,
      currentPage: state => state.currentPage
    })
  },
  methods: {
    ...mapMutations(['setSuccess']),
    ...mapActions(['updateTags', 'selectPage']),

    validateTag(tag) {
      const isTooLong = tag.length > 10;
      const isValid = /^[\w-]+$/.test(tag);
      return !isTooLong && isValid;
    },

    onTagsChanged(newTags) {
      this.tags = newTags;
    },

    open() {
      this.tag = '';
      this.invalidTag = '';
      this.tags = this.customerTags.map(t => t);
      this.setSuccess(false);
      this.$refs.modalRef.open();
    },

    close() {
      this.$refs.modalRef.close();
    },

    save() {
      const regex = /^[\w-]+$/;
      let tagsToSave = [];
      this.invalidTag = '';

      if (this.tag !== '') {
        if (this.tag.length <= 10 && regex.test(this.tag)) {
          tagsToSave.push(this.tag);
        } else {
          this.invalidTag = this.tag;
        }
      }

      if (this.invalidTag === '') {
        tagsToSave = tagsToSave.concat(this.tags);
        this.updateTags({tags: tagsToSave});
      }
    }
  },
  watch: {
    success(newValue) {
      if (newValue === true) {
        this.selectPage(this.currentPage);
        this.close();
      }
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}

.modal-content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-main-content {
  flex-grow: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.modal-footer {
  margin-top: auto;
  padding-top: 0.75rem;
  border-top: 1px solid #e5e5e5;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
</style>
